module.exports = __webpack_public_path__ + "img/yidongchuneng.035f8c31.png";